import React from "react";
import { Urls } from "../../../src/constants/UrlConstants";
import layoutStyle from "../../../src/assets/css/modules/shared/layout.css";

const errorMessages = {
  InvalidMemberDetails:
    "The details you have entered are incorrect. Please check and try again. If you believe you're entering the correct details and there is still a problem please contact us on 0800 302 9133.",
  RequiredFields: "All fields are required.",
  CorrectErrors: "Please correct the following errors:",
  EmptyMembershipNumber: "Please enter your membership number.",
  EmptyFirstName: "Please enter your first name.",
  EmptySurname: "Please enter your surname.",
  EmptyDOB: "Please enter your date of birth.",
  EmptyDepDOB: "Please enter your dependant's date of birth.",
  InvalidDOB: "Please enter your date of birth.",
  InvalidDepDOB: "Please enter your family member's date of birth.",
  InvalidMembershipNumer:
    "Please enter a valid membership number e.g. AXA/L1234567 or 1234567A.",
  InvalidFirstName:
    "Please enter First Name in valid format",
  InvalidLastName:
    "Please enter Last Name in valid format",
  OnboardingFailed: "We are having trouble finding your details please call us on 0800 169 3965 and quote reference MOL-001",
  OnboardingFailedHybridDataMismatch:"We are having trouble finding your details please call us on 0800 169 3965 and quote reference MOL-002",
  UnabletoMatchbySystemRecord:"The details you have entered are incorrect. Please check and try again. If you believe you're entering the correct details and there is still a problem please contact us on 0800 302 9133",
  MemberAlreadyRegistered: (maskedEmail = "unknown") => {
    return (
      <React.Fragment>
        <p>
          The details you've entered below are already associated with{" "}
          {maskedEmail}. Please logout using the link in the top right corner
          and log in using this email address to access Member Online.
        </p>    
        <p className="mb-0">
          Need more help?
        </p>
        <p>
          Please see our{" "}  
          <a
          className={layoutStyle.faqDecorationUnderline}
          href={Urls.FaqLink}
          rel="noopener noreferrer"
          target="_blank"
        >
           FAQ page 
        </a>                 
        {" "}for more information or call us on 0800 302 9133.
        </p>
      </React.Fragment>
    );
  },
  MemberExistInSF: (maskedEmail = "unknown") => {
    return (
      <React.Fragment>
        <p>
          We’ve noticed that you already have an online account, linked to the email address{" "}
          {maskedEmail}.
        </p>
        <p className="mb-0">
          You can only have one online account with AXA Health, but you can view more than one plan 
          using that account.
        </p>
        <br></br>
        <p className="mb-0">
          Please log out and then log in again using your existing details. Once you’ve logged in, 
          select ‘Link another plan’ from the ‘My profile’ menu to add your new plan to the account. 
          If you’ve forgotten your password, please select the Forgot your password? link.
        </p>
        <br></br>
        <p className="mb-0">
          Need more help?
        </p>
        <p>
          Please see our{" "}  
          <a
          className={layoutStyle.faqDecorationUnderline}
          href={Urls.FaqLink}
          rel="noopener noreferrer"
          target="_blank"
        >
           FAQ page 
        </a>                 
        {" "}for more information or call us on 0800 302 9133.
        </p>
      </React.Fragment>
    );
  },
  policyNotLinkedToSameAccountinSF: 
    (
      <React.Fragment>
          <p>
          Unfortunately this plan cannot be added to this account as the account is already linked to another plan.
        </p>
        <p className="mb-0">
        You'll need to create a new account with a different email address, where you will then be able to link this plan to view the details online.
        </p>
        <br></br>
        <p className="mb-0">
          Need more help?
        </p>
        <p>
          Please see our{" "}  
          <a
          className={layoutStyle.faqDecorationUnderline}
          href={Urls.FaqLink}
          rel="noopener noreferrer"
          target="_blank"
        >
           FAQ page 
        </a>                 
        {" "}for more information or call us on 0800 302 9133.
        </p>
      </React.Fragment>
    ),
  InvalidPasswordFormat: "Please enter a valid password.",
  InvalidPersonConsentPost: "Please choose your contact preference for Post.",
  InvalidPersonConsentEmail: "Please choose your contact preference for Email.",
  InvalidPersonConsentSms: "Please choose your contact preference for SMS.",
  InvalidPersonConsentTelephone:
    "Please choose your contact preference for Telephone."
};

const memberDetails = {
  title: "Member details",
  description: "Please complete the following details.",
  firstName: {
    label: "First name",
    placeholder: "Enter your name"
  },
  surname: {
    label: "Last name",
    placeholder: "Enter your surname"
  },
  dateOfBirth: {
    label: "Date of birth",
    ariaLabel: "Enter your date of birth.",
    placeholder: {
      day: "Day",
      month: "Month",
      year: "Year"
    },
    otherPerson: {
      description:
        "Please give us the date of birth of one other person covered by your plan."
    }
  },
  submit: {
    label: "Continue"
  },
  help: {
    label: "Need help?"
  },
  validationErrors: { ...errorMessages }
};

const memberDetailsForHol = { ...memberDetails };
memberDetailsForHol.validationErrors = {
  ...errorMessages,
  ...{ 
    OnboardingFailed: "We are having trouble finding your details please call us on 0800 169 3965 and quote reference COL-001",
  OnboardingFailedHybridDataMismatch:"We are having trouble finding your details please call us on 0800 169 3965 and quote reference COL-002",
  UnabletoMatchbySystemRecord:"The details you have entered are incorrect. Please check and try again. If you believe you're entering the correct details and there is still a problem please contact us on 0800 302 9133",
    InvalidMembershipNumer:"Please enter a valid membership number e.g. HOL/L1234567",
    InvalidMemberDetails:
      "The details you have entered are incorrect. Please check and try again. If you believe you're entering the correct details and there is still a problem please contact us on 01202 544032.",
    MemberAlreadyRegistered: (maskedEmail = "unknown") => {
      return (
        <React.Fragment>
          <p>
            The details you've entered below are already associated with{" "}
            {maskedEmail}. Please logout using the link in the top right corner
            and log in using this email address to access Customer Online.
          </p>
          <p className="mb-0">
            If you would like to speak to someone please call us on 01202 544032
            and we will be happy to help.
          </p>
        </React.Fragment>
      );
    }
  }
};

export const MemberDetails = {
  contentTypes: {
    Any: "Any",
    HOL: "HOL"
  },
  Any: memberDetails,
  HOL: memberDetailsForHol
};

export default MemberDetails;
